import PropTypes from 'prop-types';
import styled from 'styled-components';

import * as svars from 'assets/style/variables';

const BarContainer = styled.div`
  display: flex;
  align-items: flex-end;
  height: 1.5em;
  gap: 2.5px;
  padding: ${svars.spaceSmall} 0;
  margin-left: ${svars.spaceNormal};
`;

const Bar = styled.div`
  width: 0.25em;

  border-radius: 2px 2px 0 0;
  background: ${({ color }) => color};
  transition: background 0.2s;
`;

const BAR_HEIGHTS = [0.25, 0.5, 0.75, 1];

const getPriorityColor = (index, priority, activeColor) => {
  if (index < 2) {
    return priority > 0 ? activeColor : svars.colorGreyMedium;
  }
  return priority >= 1 ? activeColor : svars.colorGreyMedium;
};

function PriorityIconNew({ activeColor, priority }) {
  return (
    <BarContainer>
      {BAR_HEIGHTS.map((h, i) => (
        <Bar
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          style={{ height: `${h * 100}%` }}
          color={getPriorityColor(i, priority, activeColor)}
        />
      ))}
    </BarContainer>
  );
}

PriorityIconNew.propTypes = {
  priority: PropTypes.number.isRequired,
  activeColor: PropTypes.string.isRequired,
};

export default PriorityIconNew;
